import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"icon-arrow--right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.233 6.302.06 11.137l.954 1.165 5.798-5.418a.797.797 0 0 0 .248-.582.797.797 0 0 0-.248-.583L1.013.302.06 1.467l5.174 4.835Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol